import { formatDistance, isValid, parseISO } from 'date-fns';
import { unescape } from 'lodash';
import DOMPurify from 'dompurify';

import { Icon } from '@/components/icon';

import styles from './reference-block.module.scss';

export const convertSlackLinksToHtml = (slackText: string): string => {
  // Regular expression to find Slack links: <URL|TEXT>
  const slackLinkPattern = /<(http[s]?:\/\/[^|]+)\|([^>]+)>/g;

  return slackText.replace(slackLinkPattern, (_, url, text) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferral">${text}</a>`;
  });
};
export interface SlackReferenceProps {
  url: string;
  username: string;
  date: string;
  avatar?: string;
  content?: string;
  onOpen?: () => void;
}

export const SlackReference = ({
  url,
  avatar,
  username,
  content,
  date,
  onOpen,
}: SlackReferenceProps) => {
  const relativeTime = isValid(parseISO(date ?? ''))
    ? formatDistance(new Date(date), new Date(), { addSuffix: true })
    : '';

  const formattedContent = {
    __html: DOMPurify.sanitize(convertSlackLinksToHtml(unescape(content))),
  };

  return (
    <div className={styles.slackBlock}>
      {avatar !== undefined ? (
        <img src={avatar} className={styles.avatar} height={32} width={32} />
      ) : (
        <div className={styles.avatar}>
          <Icon name="Slack" size={32} />
        </div>
      )}
      <div className={styles.username}>{username}</div>
      <div className={styles.timestamp}>{relativeTime}</div>
      <a
        href={url}
        rel="noopener noreferrer nofollow"
        target="_blank"
        className={styles.iconLink}
        draggable={false}
        onClick={onOpen}>
        <Icon name="ExternalLink" size={16} />
      </a>
      <div className={styles.content} dangerouslySetInnerHTML={formattedContent} />
    </div>
  );
};
